import { Check, Copy } from 'lucide-react'

import * as Input from '@/components/input'
import { useCopyText } from '@/hooks/use-copy-text'

interface HashInputControlProps {
  label: string
  hashValue?: string
  testId?: string
}
export function HashInputControl({
  hashValue,
  label,
  testId = '',
}: HashInputControlProps) {
  const { isCopied, copyInviteLink } = useCopyText({
    value: hashValue,
    testId,
  })

  return (
    <div className="w-full">
      <Input.Label htmlFor="contract_hash">{label}</Input.Label>
      <Input.Root>
        <Input.Control
          id="contract_hash"
          readOnly
          type="text"
          value={hashValue}
          placeholder="Valor do hash"
          data-testid={testId}
        />
        <Input.Prefix
          aria-disabled={!hashValue}
          onClick={copyInviteLink}
          className="cursor-pointer text-monochromatic-400 *:size-5 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
          data-testid="hash-copy-input-control-copy-button"
        >
          {isCopied ? <Check /> : <Copy />}
        </Input.Prefix>
      </Input.Root>
    </div>
  )
}
